export const ACTION_FAMILY = {
  transfer: "transfer",
  yieldWithdraw: "yield-withdraw",
  yieldRedeem: "yield-redeem",
  swap: "swap",
  bridge: "bridge",
  yieldDeposit: "yield-deposit",
  liquidity: "liquidity",
  call: "call",
} as const;

export const ACTION_TYPES = [
  ACTION_FAMILY.transfer,
  ACTION_FAMILY.yieldWithdraw,
  ACTION_FAMILY.yieldRedeem,
  ACTION_FAMILY.swap,
  ACTION_FAMILY.bridge,
  ACTION_FAMILY.yieldDeposit,
  ACTION_FAMILY.liquidity,
  ACTION_FAMILY.call,
] as const;

export type ActionType = (typeof ACTION_TYPES)[number];

export const EVM_ACTION_TYPES = [
  "erc20_transfer",
  "float_transfer",
  "deliver_proceeds",
  "native_transfer",
  "bebop_rfq_swap",
  "bebop_jam_swap",
  "ondo_direct_mint_redeem",
  "ondo_direct_batch_rebalance",
  "reality_via_bitget_swap",
  "lifi_swap",
  "lifi_bridge",
  "erc4626_deposit",
  "erc4626_withdraw",
  "erc4626_redeem",
  "fluid_vault_deposit",
  "fluid_vault_withdraw",
  "fluid_vault_redeem",
  "morpho_vault_deposit",
  "morpho_vault_withdraw",
  "morpho_vault_redeem",
  "aave_v3_deposit",
  "aave_v3_withdraw",
  "aave_v3_gateway_deposit",
  "aave_v3_gateway_withdraw",
  "weth_wrap",
  "weth_unwrap",
  "zeroex_swap",
  "erc20_approve",
  "evm_call",
  "rebalance_batch",
  "cl_mint",
  "cl_increase",
  "cl_decrease",
  "cl_collect",
  "cl_burn",
] as const;

export type EvmActionType = (typeof EVM_ACTION_TYPES)[number];

export const SVM_ACTION_TYPES = ["spl_transfer"] as const;

export type SvmActionType = (typeof SVM_ACTION_TYPES)[number];

export const EXPLICIT_ACTION_TYPES = [
  ...EVM_ACTION_TYPES,
  ...SVM_ACTION_TYPES,
] as const;

export type ExplicitActionType = (typeof EXPLICIT_ACTION_TYPES)[number];

export type InputActionType = ActionType | ExplicitActionType;

const actionTypeSet: ReadonlySet<string> = new Set(ACTION_TYPES);
const evmActionTypeSet: ReadonlySet<string> = new Set(EVM_ACTION_TYPES);
const explicitActionTypeSet: ReadonlySet<string> = new Set(
  EXPLICIT_ACTION_TYPES,
);

export const isActionType = (value: string): value is ActionType =>
  actionTypeSet.has(value);

export const isEvmActionType = (value: string): value is EvmActionType =>
  evmActionTypeSet.has(value);

export const isExplicitActionType = (
  value: string,
): value is ExplicitActionType => explicitActionTypeSet.has(value);

export const isInputActionType = (value: string): value is InputActionType =>
  isActionType(value) || isExplicitActionType(value);
